{
  "ui": {
    "feedback": "Tilbakemelding",
    "credits": "Medvirkende",
    "currentMaintainer": "Nåværende vedlikeholder",
    "maintainerPeriod": "Fra 2026 og videre",
    "originalTeam": "Det opprinnelige teamet",
    "creditsCampaigns": "Jungel og jul",
    "moreSettings": "Flere innstillinger",
    "chooseLanguage": "Velg språk",
    "notebookTools": "Verktøy for notatboken",
    "visualGuide": "Bildeveiledning",
    "templeSoon": "Kommer snart",
    "playAdventure": "Spill",
    "story": "Historien",
    "loadingAdventure": "Vi pakker til eventyret…",
    "storyOpening": "En skoletur til jungelen. Marco og Sophia utforsker sammen med vennene sine. En fargerik fugl fanger Marcos oppmerksomhet, og han følger den mellom trærne. Plutselig er han alene. Hjelp oppdagerne med å finne veien!",
    "storyEnding": "Marco og Sophia når det tapte tempelet sammen. Et mystisk ansikt vokter inngangen. Et nytt eventyr venter!",
    "blockCategories": "Faner i notatboken",
    "actions": "Handlinger",
    "loops": "Løkker",
    "conditions": "Betingelser",
    "title": "Run Marco! — Et eventyr i notatboken din",
    "home": "Run Marco-startside",
    "map": "Eventyrkart",
    "worlds": "Velg et eventyr",
    "notebook": "Notatboken min",
    "notebookToggle": "Åpne eller lukk notatboken",
    "notebookOpen": "Åpne notatboken",
    "notebookClose": "Se på stien",
    "page": "Side {number}",
    "level": "Rute {number}",
    "run": "Kom igjen!",
    "stop": "Stopp",
    "step": "Ett steg",
    "stepTitle": "Kjør én instruksjon",
    "reset": "Tilbake til start",
    "add": "Legg til",
    "addLabel": "Velg en blokk å legge til",
    "addHint": "Sett blokkene sammen, og trykk på Spill.",
    "undo": "Angre",
    "clear": "Ny side",
    "hint": "Et lite hint",
    "help": "Slik spiller du",
    "settings": "Innstillinger",
    "language": "Spillspråk",
    "blockLanguage": "Blokkspråk",
    "blockLanguageNote": "Du kan velge et annet språk for blokkene.",
    "musicOn": "Slå på lyden",
    "musicOff": "Slå av lyden",
    "sound": "Musikk og lydeffekter",
    "speed": "Eventyrfart",
    "chooseExplorer": "Velg oppdageren din",
    "explorer": "Oppdager",
    "marco": "Marco",
    "sophia": "Sophia",
    "close": "Lukk",
    "done": "La oss utforske!",
    "loading": "Vi finner stien…",
    "loadError": "Eventyret kunne ikke lastes inn. Last siden på nytt for å prøve igjen.",
    "imageError": "Noen bilder kunne ikke lastes inn. Last siden på nytt.",
    "gemGoal": "Finn edelstenen",
    "goal": "Finn den gylne stjernen",
    "cover": "Tenn hver rute nøyaktig én gang",
    "lit": "{count} / {total} ruter tent",
    "explored": "{count} / {total} ruter utforsket",
    "facing": "Ser mot {direction} {arrow}",
    "boardLabel": "{name} på {level}, ser mot {direction}. {steps}. {objective}.",
    "up": "opp",
    "down": "ned",
    "left": "venstre",
    "right": "høyre",
    "steps_one": "{count} steg",
    "steps_other": "{count} steg",
    "blocks_one": "{count} blokk",
    "blocks_other": "{count} blokker",
    "stars_one": "{count} stjerne",
    "stars_other": "{count} stjerner",
    "place": "Legg til blokker",
    "atEnd": "Til slutt",
    "insideRepeat": "Inni gjenta {number}",
    "insideIf": "Inni hvis {number}",
    "insideElse": "Inni ellers {number}",
    "readyFirst": "Et lite steg. Legg til en fremoverblokk, og kom igjen!",
    "ready": "Hvor skal vi? Lag en plan i notatboken.",
    "back": "Tilbake ved start. Blokkene dine er klare for et nytt forsøk.",
    "empty": "Legg først til en blokk i notatboken.",
    "win": "Du fant veien!",
    "winCover": "Du lyste opp stien!",
    "winDetails": "{steps} · {blocks}",
    "brilliant": "For et eventyr!",
    "simpler": "Kan du bruke færre blokker?",
    "complete": "Ruten er fullført! De beste stjernene dine er lagret.",
    "next": "Neste rute",
    "allWorlds": "Flere eventyr",
    "replay": "Spill igjen",
    "shortGoal": "Nesten! Legg til flere blokker for å nå stjernen.",
    "shortGem": "Nesten! Legg til flere blokker for å nå edelstenen.",
    "shortCover": "Noen ruter er fortsatt mørke. Hvordan når vi dem?",
    "checking": "Vi ser på stien…",
    "paused": "Stoppet. Spill begynner fra starten igjen.",
    "going": "Av gårde!",
    "stepped": "Ett steg nærmere. Trykk på Ett steg eller Spill for å fortsette.",
    "clueCover": "Start ved en kant og følg hele formen. Et hopp passerer over en rute uten å tenne den.",
    "clueCondition": "Se på stien foran deg. En betingelse hjelper oppdageren din med å velge hva som skal gjøres.",
    "clueRepeat": "Hvilke steg gjentar seg? Sett mønsteret inn i en gjentakelsesblokk.",
    "clueForward": "Fremover følger retningen oppdageren din ser. Tell rutene frem til stjernen.",
    "clueGem": "Fremover følger retningen oppdageren din ser. Tell rutene frem til edelstenen.",
    "clueTurn": "Å snu endrer retning uten å flytte deg. Følg stien med fingeren.",
    "mapNote": "Velg en rute. De beste stjernene dine blir lagret.",
    "mapLevel": "Rute {number}: {name}. {stars}.",
    "locked": "Fullfør forrige rute for å låse opp denne.",
    "soundBlocked": "Trykk på lydknappen for å høre eventyret.",
    "clearTitle": "Begynne på en ny side?",
    "clearNote": "Blokkene for denne ruten blir slettet. Angre kan hente dem tilbake.",
    "keep": "Behold blokkene mine",
    "clearConfirm": "Slett blokker",
    "fresh": "En ny side. Hvor fører den neste planen din oss?",
    "localProgress": "Fremgangen din lagres på denne enheten.",
    "helpBuild": "Lag en plan",
    "helpBuildText": "Dra blokker inn i notatboken og koble dem sammen, eller trykk på en blokk for å legge den til. Velg «Inni gjenta» for steg i en løkke.",
    "helpTurn": "Følg oppdageren din",
    "helpTurnText": "Fremover følger blikket. Venstre og høyre snur på stedet. Et hopp går to ruter frem.",
    "helpTry": "Prøv, se, prøv igjen",
    "helpTryText": "Trykk på Spill for planen eller Ett steg for én instruksjon. Den buede pilen går tilbake til start og beholder blokkene.",
    "helpWorlds": "Hvert eventyr har et mål",
    "helpWorldsText": "Finn edelstenen i Jungelen. Tenn hver ledige rute én gang i juleeventyret. Fullfør reparasjonene og de synlige målene i Tempelet og Egeerhavet, og nå utgangen.",
    "noTrail": "Det er ingen sti der! Prøv å snu først.",
    "broken": "Den broen er ødelagt. Kan du hoppe over den?",
    "blocked": "Noe sperrer veien. Prøv et hopp eller en annen rute.",
    "alreadyLit": "Den ruten er allerede tent. Besøk hver rute bare én gang.",
    "loopError": "Planen gjentar seg uten ende. Prøv å endre løkken.",
    "repeatError": "Velg et antall gjentakelser fra 1 til 99.",
    "unsupported": "Fjern blokken som ikke støttes, og prøv igjen.",
    "connect": "Koble blokkene til én kjede, og trykk på Spill.",
    "path": "sti",
    "backpack": "Ryggsekk",
    "templeGems": "Tempelets edelstener",
    "gemsCollected": "Edelstener: {count} / {total}",
    "gemsReady": "Alle edelstenene er samlet!",
    "aegeanTitle": "Egeerhavets hemmeligheter",
    "harbour": "Havn",
    "aegeanDescription": "Utforsk havnen: reparer stasjoner, gjenbruk rutiner og send et tall med hver oppgave.",
    "templeBetaNote": "Beta · Vi reviderer oppgavene og leksjonene",
    "aegeanBetaNote": "Beta · De første 3 havnebrettene",
    "seasonal": "Sesongeventyr",
    "choosePreview": "Velg et prøvebrett",
    "repairs": "Reparasjoner",
    "reachExit": "Nå utgangen",
    "taskRequirements": "Oppdragets mål",
    "lessonGuided": "Veiledet øvelse · fullfør det oppgitte programmet",
    "lessonRepair": "Feilsøking · rett det oppgitte programmet",
    "lessonChallenge": "Utfordring · lag ditt eget program",
    "acc_define_parameter": "Rutine",
    "acc_call_argument": "Kall rutine",
    "acc_repeat_parameter": "Gjenta med inndata",
    "parameter": "parameter",
    "argument": "send",
    "callInput": "Inndata for dette kallet",
    "inputWaiting": "Kjør programmet eller én instruksjon om gangen for å se neste inndata.",
    "argumentMismatch": "En rutine med en parameter trenger et kall med et tall. Uten parameter brukes et vanlig kall.",
    "unsetParameter": "Bruk parameteren bare i rutinen som mottar den. Parametere er atskilt fra det delte minnet.",
    "memoryObjective": "Sjekk reparasjonsloggen og kravene ved utgangen. Alle programmer som oppfyller dem, godtas.",
    "gate": "Veien er sperret. Sjekk de uferdige reparasjonene.",
    "noPickup": "Still deg på verktøyet før du plukker det opp.",
    "creditLead": "Teamledelse og programvareutvikling",
    "creditArt": "Illustrasjon og kulisser",
    "creditAnimation": "Animasjon",
    "creditUX": "Grensesnitt- og brukeropplevelsesdesign",
    "creditDesign": "Spilldesign",
    "creditStory": "Historie",
    "creditAudio": "Musikk og lydteknikk",
    "lightLamp": "Tenn lampen",
    "oilLamp": "Oljelampe",
    "dustyStation": "støvete stasjon",
    "betaLabel": "Beta",
    "noLamp": "Stå på en slukket lampe før du tenner den.",
    "collected": "Verktøy plukket opp · klart til bruk",
    "dustyPrompt": "Stå på en støvete stasjon før du bruker penselen.",
    "lampMissing": "Plukk opp oljelampen først. Se i sekken.",
    "recursiveRoutine": "Denne rutinen kaller seg selv. Bruk en annen rutine; rekursive kall er ikke tilgjengelige ennå."
  },
  "content": {
    "jungle.title": "Jungelekspedisjon",
    "jungle.description": "Følg stien til det tapte tempelet.",
    "jungle-1": "Første steg",
    "jungle-2": "Litt lenger",
    "jungle-3": "Rundt hjørnet",
    "jungle-4": "Bytt retning",
    "jungle-5": "Følg stien",
    "jungle-6": "En ny rute",
    "jungle-7": "Nye stier",
    "jungle-8": "Jungelkryss",
    "jungle-9": "Finn veien",
    "jungle-10": "Tenk fremover",
    "jungle-11": "Den lange stien",
    "jungle-12": "En svingete rute",
    "jungle-13": "Et modig sprang",
    "jungle-14": "Mønstre dukker opp",
    "jungle-15": "Gjenta rytmen",
    "jungle-16": "Velg en sti",
    "jungle-17": "Se før du hopper",
    "jungle-18": "Les stien",
    "jungle-19": "En lur omvei",
    "jungle-20": "Under trekronene",
    "jungle-21": "Brobygger",
    "jungle-22": "Bortenfor elven",
    "jungle-23": "Utforsk ruinene",
    "jungle-24": "Stein og tre",
    "jungle-25": "Et større hopp",
    "jungle-26": "Følg sporene",
    "jungle-27": "Høyere opp",
    "jungle-28": "Fortsett å utforske",
    "jungle-29": "Svingete stier",
    "jungle-30": "Den hemmelige hagen",
    "jungle-31": "Skjulte mønstre",
    "jungle-32": "Gamle stier",
    "jungle-33": "De siste svingene",
    "jungle-34": "Mot tempelet",
    "jungle-35": "Nesten fremme",
    "jungle-36": "Det tapte tempelet",
    "winter.title": "Vintersti",
    "winter.description": "La hvert fotspor lyse.",
    "winter-1": "Steg i snøen",
    "winter-2": "En annen retning",
    "winter-3": "Frosne hjørner",
    "winter-4": "Den lange omveien",
    "winter-5": "Snøfnugg",
    "winter-6": "Vinterløkker",
    "winter-7": "Isoppdager",
    "winter-8": "Svinger og vendinger",
    "winter-9": "Iskald logikk",
    "winter-10": "Mønsterfinner",
    "winter-11": "Stiens mester",
    "winter-12": "Vinterunder",
    "temple.title": "Det tapte tempelet",
    "temple.description": "Førti sammenhengende rom. Gjenopprett et himmelinstrument med verktøy, minne og egne rutiner."
  },
  "blockly": {
    "ARIA_LABEL_TRASH_EMPTY": "Papirkurven er tom",
    "OPEN_TRASH": "Åpne papirkurven",
    "BLOCK_LABEL_BEGIN_STACK": "Start på stabel",
    "WORKSPACE_LABEL_1_STACK": "1 stabel blokker",
    "WORKSPACE_LABEL_MANY_STACKS": "%1 stabler med blokker",
    "ARIA_TYPE_FIELD_NUMBER": "tall",
    "ARIA_TYPE_FIELD_DROPDOWN": "nedtrekksliste",
    "ARIA_TYPE_FIELD_IMAGE": "bilde",
    "WORKSPACE_LABEL_PLAIN": "Notatboken min",
    "FIELD_LABEL_EDIT_PREFIX": "Rediger %1",
    "BLOCK_LABEL_HAS_INPUT": "har inndata",
    "BLOCK_LABEL_HAS_INPUTS": "har flere inndata",
    "BLOCK_LABEL_HAS_BRANCHES": "har %1 grener",
    "FIELD_LABEL_OPTION_INDEX": "Valg %1",
    "INPUT_LABEL_EMPTY": "Tom",
    "BLOCK_LABEL_DISABLED": "deaktivert",
    "BLOCK_LABEL_COLLAPSED": "slått sammen",
    "BLOCK_LABEL_BEGIN_PREFIX": "Start: %1",
    "INPUT_LABEL_END_STATEMENT": "Slutt: %1",
    "ARIA_TYPE_FIELD_TEXT_INPUT": "tekst",
    "ARIA_TYPE_FIELD_INPUT": "inndata",
    "ARIA_TYPE_FIELD_TEXT_INPUT_ARGUMENT": "navn på inndata",
    "ARIA_TYPE_FIELD_TEXT_INPUT_PROCEDURE": "rutinenavn"
  }
}
